const {AggregatedModelTableDatasetConfiguration} = require("./configuration/aggregated-model-table-dataset-configuration");
const {PreviewTab} = require("../preview-tab/preview-tab");

const AggregatedModelTableDatasetStepTabs = {
    configuration: AggregatedModelTableDatasetConfiguration,
    preview: PreviewTab,
};
exports.AggregatedModelTableDatasetStepTabs = AggregatedModelTableDatasetStepTabs;
